module.exports = __webpack_public_path__ + "img/phone1.89b7d24a.png";